(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/router.js');

'use strict';

svs.player_login.Router = svs.app.ServerSideHelper.ServerSideRouterDecorator.decorate({
  initialize() {
    this.setDefaultRegion(svs.player_login.app.getRegion());
    this.on('route', () => {
      svs.player_login.logger.debug("Current url: ".concat(decodeURIComponent(window.location.href)));
    });
  },
  routes: svs.core.data.routes,
  hasRoute(route) {
    let internalRoute = route;
    if (~internalRoute.indexOf('?')) {
      internalRoute = internalRoute.substring(0, internalRoute.indexOf('?'));
    }
    if (route) {
      if (route.charAt() === '/') {
        internalRoute = route.substring(1);
      }
      if (this.routes[internalRoute]) {
        return true;
      }
    }
    return false;
  },
  start() {
    const model = svs.player_login.radio.request('loginModel');
    const LoginTypes = svs.accountservices.authenticate.definitions.LoginTypes;
    let view;
    if (svs.core.detect.formfactor.mobile() || model.get('isCustomerRegistration')) {
      view = svs.player_login.views.Start;
    } else {
      switch (model.get('loginMethod')) {
        case LoginTypes.DESKTOP_BANKID_MOBILE_QR:
        case LoginTypes.DESKTOP_BANKID_MOBILE_SSN:
          view = svs.player_login.views.bankid.OtherDevice;
          break;
        case LoginTypes.DESKTOP_BANKID:
          view = svs.player_login.views.bankid.SameDevice;
          break;
        case LoginTypes.DESKTOP_FREJA:
          view = svs.player_login.views.freja.OtherDevice;
          break;
        case LoginTypes.DESKTOP_FREJA_SAME_DEVICE:
          svs.player_login.app.getRegion().show(new svs.player_login.views.Start({
            model
          }));
          break;
        default:
          view = svs.player_login.views.Start;
          break;
      }
    }
    if (view) {
      this.showView(view, {
        model
      });
    }
  },
  chooseLoginMethod() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.Start, {
      model
    });
  },
  bankIdFallback() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.bankid.Fallback, {
      model
    });
  },
  freja() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.freja.OtherDevice, {
      model
    });
  },
  frejaSameDevice() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.freja.SameDevice, {
      model
    });
  },
  async gamingInfo(lastLoginTimeFromServer) {
    var _svs$components$Stora;
    const model = svs.player_login.radio.request('loginModel');
    const firstTimeLoginPnp = svs.accountservices.authenticate.isFirstPnp;
    let hasLimits = true;
    let showStepIndicator = false;
    let depositValue = false;
    try {
      const _await$svs$core$jupit = await svs.core.jupiter.callAsync({
          method: 'GET',
          path: '/player/1/gamelimits'
        }),
        response = _await$svs$core$jupit.response;
      if (response.deposit === null) {
        hasLimits = false;
        showStepIndicator = true;
      }
    } catch (e) {
      svs.player_login.logger.warn('Failed to fetch player limits clientside for gameInfo in router', e);
    }
    if ((_svs$components$Stora = svs.components.Storage) !== null && _svs$components$Stora !== void 0 && (_svs$components$Stora = _svs$components$Stora.browser) !== null && _svs$components$Stora !== void 0 && (_svs$components$Stora = _svs$components$Stora.get('depositValues', 'quick-deposit')) !== null && _svs$components$Stora !== void 0 && _svs$components$Stora.amount) {
      showStepIndicator = true;
      depositValue = true;
    }
    svs.player_login.data.login.hasDepositAndTimeLimitsSet = hasLimits;
    model.set('firstTimePnp', firstTimeLoginPnp);
    model.set('hasDepositAndTimeLimitsSet', hasLimits);
    model.set('showStepIndicator', showStepIndicator);
    model.set('depositValue', depositValue);
    const dateTimeString = parseInt(model.get('lastLoginTime') || lastLoginTimeFromServer, 10);
    const lastLoginTime = new Date(dateTimeString);
    const startOfLogin = model.get('startOfLogin');
    const logger = svs.core.log.getLogger('module:player-login');
    svs.core.userSession.remove('lastLoginTime');
    if (!(lastLoginTime instanceof Date && !isNaN(lastLoginTime))) {
      logger.info("Can not parse last login time strings: ".concat(dateTimeString || lastLoginTimeFromServer));
    } else if (startOfLogin < lastLoginTime.getTime()) {
      logger.info("Device with incorrect clock: ".concat(new Date(startOfLogin).toISOString()));
    }
    this.showView(svs.player_login.views.GamingInfo, {
      model
    });
  },
  bankidPoll() {
    const model = svs.player_login.radio.request('loginModel');
    if (model.get('isPoker')) {
      svs.core.template.updateConfig({
        hideBalanceBar: true
      });
    }
    this.showView(svs.player_login.views.bankid.Poll, {
      model
    });
  },
  frejaCustreg() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.Start, {
      isFrejaNewCustomerLogin: true,
      model
    });
  },
  frejaPoll() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.freja.Poll, {
      model
    });
  },
  bankidSameDevice() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.bankid.SameDevice, {
      model
    });
  },
  bankidOtherDevice() {
    const model = svs.player_login.radio.request('loginModel');
    this.showView(svs.player_login.views.bankid.OtherDevice, {
      model
    });
  },
  pokerNotCustomer() {
    this.showView(svs.player_login.views.poker.NotCustomer, {
      model: svs.player_login.radio.request('loginModel')
    });
  },
  pokerPlayscanMessage() {
    this.showView(svs.player_login.views.poker.PlayscanMessage, {
      model: svs.player_login.radio.request('loginModel')
    });
  },
  loginCheck() {
    const loginCheckOptions = svs.player_login.data.loginCheckOptions;
    this.showView(svs.player_login.views.loginChecks.LoginCheck, {
      component: this.getComponent(loginCheckOptions.component),
      'component-options': loginCheckOptions,
      useMarionette: loginCheckOptions.useMarionette
    });
  },
  getComponent(comp) {
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    const parts = comp.split('.');
    let part;
    let obj = context;
    for (let i = 0, iLen = parts.length; i < iLen; ++i) {
      part = parts[i];
      obj = obj[part];
      if (obj === undefined || obj === null) {
        return;
      }
    }
    return obj;
  }
});

 })(window);